import gql from 'graphql-tag';
import {
    EVENT_FORM_FRAGMENT,
    GUIDE_FRAGMENT,
    G_ENTITY_TYPE,
    G_EXTERNAL_LINK,
    G_INFORMATION_ITEM,
    G_NEWSFEED_ITEM_FRAGMENT,
    G_PROGRAM_ITEM,
    G_STORY_FRAGMENT
} from 'graphql/fragment/guideFragment';

export const G_CREATE_GUIDE = gql`
    mutation CreateGuide($guideInput: GuideInput!, $worldMapInput: WorldMapInput!) {
        g_createGuide(guideInput: $guideInput, worldMapInput: $worldMapInput) {
            guide {
                guideId
            }
            map {
                worldMapId
            }
            token
        }
    }
`;

export const G_UPDATE_GUIDE = gql`
    mutation UpdateGuide($guideId: String!, $guideInput: GuideInput!, $token: String) {
        g_updateGuide(guideId: $guideId, guide: $guideInput, token: $token) {
            guide {
                ...GGuide
            }
        }
    }

    ${GUIDE_FRAGMENT}
`;

export const G_DELETE_GUIDE = gql`
    mutation DeleteGuide($guideId: String!, $token: String) {
        g_deleteGuide(guideId: $guideId, token: $token) {
            success
        }
    }
`;

export const G_CLONE_GUIDE = gql`
    mutation CloneGuide($guideId: String!) {
        g_cloneGuide(guideId: $guideId) {
            guide {
                guideId
            }
            map {
                worldMapId
            }
            token
        }
    }
`;

export const G_LINK_INFORMATION = gql`
    mutation LinkInformation($guideId: String!, $storyId: String!, $token: String) {
        g_linkInformation(guideId: $guideId, storyId: $storyId, token: $token) {
            guide {
                guideId
                informationItems {
                    guideInformationItemId
                }
            }
            informationItem {
                ...GInformationItem
            }
        }
    }

    ${G_INFORMATION_ITEM}
`;

export const G_UNLINK_INFORMATION = gql`
    mutation UnlinkInformation($guideId: String!, $storyId: String!, $token: String) {
        g_unlinkInformation(guideId: $guideId, storyId: $storyId, token: $token) {
            guide {
                guideId
                informationItems {
                    guideInformationItemId
                }
            }
        }
    }
`;

export const G_CREATE_ENTITY_TYPE = gql`
    mutation CreateEntityType($guideId: String!, $input: GuideEntityTypeInput!, $token: String) {
        g_createEntityType(guideId: $guideId, input: $input, token: $token) {
            guide {
                guideId
                entityTypes {
                    guideEntityTypeId
                }
            }
            entityType {
                ...GEntityType
            }
        }
    }

    ${G_ENTITY_TYPE}
`;

export const G_UPDATE_ENTITY_TYPE = gql`
    mutation UpdateEntityType(
        $guideId: String!
        $guideEntityTypeId: String!
        $input: GuideEntityTypeInput!
        $token: String
    ) {
        g_updateEntityType(
            guideId: $guideId
            guideEntityTypeId: $guideEntityTypeId
            input: $input
            token: $token
        ) {
            guide {
                guideId
            }
            entityType {
                ...GEntityType
            }
        }
    }

    ${G_ENTITY_TYPE}
`;

export const G_DELETE_ENTITY_TYPE = gql`
    mutation DeleteEntityType($guideId: String!, $guideEntityTypeId: String!, $token: String) {
        g_deleteEntityType(
            guideId: $guideId
            guideEntityTypeId: $guideEntityTypeId
            token: $token
        ) {
            guide {
                guideId
                entityTypes {
                    guideEntityTypeId
                }
            }
        }
    }
`;

export const G_LINK_STORY_TO_ENTITY_TYPE = gql`
    mutation LinkStoryToEntityType(
        $guideId: String!
        $guideEntityTypeId: String!
        $storyId: String!
        $token: String
    ) {
        g_linkStoryToEntityType(
            guideId: $guideId
            guideEntityTypeId: $guideEntityTypeId
            storyId: $storyId
            token: $token
        ) {
            guide {
                guideId
            }
            entityType {
                guideEntityTypeId
                storyIds
            }
        }
    }
`;

export const G_UNLINK_STORY_FROM_ENTITY_TYPE = gql`
    mutation UnlinkStoryFromEntityType(
        $guideId: String!
        $guideEntityTypeId: String!
        $storyId: String!
        $token: String
    ) {
        g_unlinkStoryFromEntityType(
            guideId: $guideId
            guideEntityTypeId: $guideEntityTypeId
            storyId: $storyId
            token: $token
        ) {
            guide {
                guideId
            }
            entityType {
                guideEntityTypeId
                storyIds
            }
        }
    }
`;

export const G_CREATE_NEWSFEED_ITEM = gql`
    mutation CreateNewsfeedItem($guideId: String!, $input: GuideNewsfeedItemInput!) {
        g_createNewsfeedItem(guideId: $guideId, input: $input) {
            guide {
                guideId
                newsfeedItems {
                    guideNewsfeedItemId
                }
            }
            newsfeedItem {
                ...GNewsfeedItem
            }
        }
    }

    ${G_NEWSFEED_ITEM_FRAGMENT}
`;

export const G_UPDATE_NEWSFEED_ITEM = gql`
    mutation UpdateNewsfeedItem(
        $guideId: String!
        $guideNewsfeedItemId: String!
        $input: GuideNewsfeedItemInput!
    ) {
        g_updateNewsfeedItem(
            guideId: $guideId
            guideNewsfeedItemId: $guideNewsfeedItemId
            input: $input
        ) {
            guide {
                guideId
            }
            newsfeedItem {
                ...GNewsfeedItem
            }
        }
    }

    ${G_NEWSFEED_ITEM_FRAGMENT}
`;

export const G_DELETE_NEWSFEED_ITEM = gql`
    mutation DeleteNewsfeedItem($guideId: String!, $guideNewsfeedItemId: String!) {
        g_deleteNewsfeedItem(guideId: $guideId, guideNewsfeedItemId: $guideNewsfeedItemId) {
            guide {
                guideId
                newsfeedItems {
                    guideNewsfeedItemId
                }
            }
        }
    }
`;

export const G_SEND_NEWSFEED_NOTIFICATION_TEST = gql`
    mutation SendNewsfeedNotificationTest(
        $guideId: String!
        $guideNewsfeedItemId: String!
        $userIds: [String!]!
    ) {
        g_sendTestNotificationsForNewsfeedItem(
            guideId: $guideId
            guideNewsfeedItemId: $guideNewsfeedItemId
            userIds: $userIds
        ) {
            newsfeedItem {
                ...GNewsfeedItem
            }
        }
    }

    ${G_NEWSFEED_ITEM_FRAGMENT}
`;

export const G_SEND_NEWSFEED_NOTIFICATION_ALL = gql`
    mutation SendNewsfeedNotificationAll($guideId: String!, $guideNewsfeedItemId: String!) {
        g_sendAllNotificationsForNewsfeedItem(
            guideId: $guideId
            guideNewsfeedItemId: $guideNewsfeedItemId
        ) {
            newsfeedItem {
                ...GNewsfeedItem
            }
        }
    }

    ${G_NEWSFEED_ITEM_FRAGMENT}
`;

export const G_CREATE_PROGRAM_ITEM = gql`
    mutation CreateProgramItem($guideId: String!, $input: GuideProgramItemInput!, $token: String) {
        g_createProgramItem(guideId: $guideId, input: $input, token: $token) {
            guide {
                guideId
                programItems {
                    guideProgramItemId
                }
            }
            programItem {
                ...GProgramItem
            }
        }
    }

    ${G_PROGRAM_ITEM}
`;

export const G_UPDATE_PROGRAM_ITEM = gql`
    mutation UpdateProgramItem(
        $guideId: String!
        $guideProgramItemId: String!
        $input: GuideProgramItemInput!
        $token: String
    ) {
        g_updateProgramItem(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            input: $input
            token: $token
        ) {
            guide {
                guideId
            }
            programItem {
                ...GProgramItem
            }
        }
    }

    ${G_PROGRAM_ITEM}
`;

export const G_DELETE_PROGRAM_ITEM = gql`
    mutation DeleteProgramItem($guideId: String!, $guideProgramItemId: String!, $token: String) {
        g_deleteProgramItem(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            token: $token
        ) {
            guide {
                guideId
                programItems {
                    guideProgramItemId
                }
            }
        }
    }
`;

export const G_ADD_PROGRAM_ITEM_TO_CATEGORY = gql`
    mutation AddProgramItemToCategory(
        $guideId: String
        $guideProgramItemId: String!
        $worldMapSetId: String!
        $token: String
    ) {
        g_addProgramToCategory(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            worldMapSetId: $worldMapSetId
            token: $token
        ) {
            guide {
                guideId
                programItems {
                    guideProgramItemId
                    categories {
                        worldMapSetId
                    }
                }
            }
            category {
                worldMapSetId
            }
        }
    }
`;

export const G_REMOVE_PROGRAM_ITEM_FROM_CATEGORY = gql`
    mutation RemoveProgramItemFromCategory(
        $guideId: String
        $guideProgramItemId: String!
        $worldMapSetId: String!
        $token: String
    ) {
        g_removeProgramFromCategory(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            worldMapSetId: $worldMapSetId
            token: $token
        ) {
            guide {
                guideId
                programItems {
                    guideProgramItemId
                    categories {
                        worldMapSetId
                    }
                }
            }
            category {
                worldMapSetId
            }
        }
    }
`;

export const G_LINK_STORY_TO_PROGRAM = gql`
    mutation LinkStoryToProgramItem(
        $guideId: String!
        $guideProgramItemId: String!
        $storyId: String!
        $token: String
    ) {
        g_linkStoryToProgramItem(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            storyId: $storyId
            token: $token
        ) {
            guide {
                guideId
            }
            programItem {
                guideProgramItemId
                storyIds
                loadDetailFromStoryId
            }
        }
    }
`;

export const G_UNLINK_STORY_FROM_PROGRAM = gql`
    mutation UnlinkStoryFromProgramItem(
        $guideId: String!
        $guideProgramItemId: String!
        $storyId: String!
        $token: String
    ) {
        g_unlinkStoryFromProgramItem(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            storyId: $storyId
            token: $token
        ) {
            guide {
                guideId
            }
            programItem {
                guideProgramItemId
                storyIds
                loadDetailFromStoryId
            }
        }
    }
`;

export const G_CREATE_STORY_TO_GUIDE_ENTITY_TYPE = gql`
    mutation CreateStoryToGuideEntityType(
        $guideId: String!
        $story: StoryInput!
        $cards: [CardInputWithType!]!
        $assignToEntityTypeId: String
        $token: String
    ) {
        g_createStoryToGuide(
            guideId: $guideId
            story: $story
            cards: $cards
            token: $token
            assignToEntityTypeId: $assignToEntityTypeId
        ) {
            guide {
                guideId
                stories {
                    storyId
                }
                entityTypes {
                    guideEntityTypeId
                    storyIds
                }
            }
            story {
                storyId
                ...GStory
            }
        }
    }

    ${G_STORY_FRAGMENT}
`;

export const G_CREATE_STORY_TO_GUIDE_PROGRAM = gql`
    mutation CreateStoryToGuideProgram(
        $guideId: String!
        $story: StoryInput!
        $cards: [CardInputWithType!]!
        $assingToProgramId: String
        $token: String
    ) {
        g_createStoryToGuide(
            guideId: $guideId
            story: $story
            cards: $cards
            token: $token
            assingToProgramId: $assingToProgramId
        ) {
            guide {
                guideId
                stories {
                    storyId
                }
                programItems {
                    guideProgramItemId
                    storyIds
                }
            }
            story {
                storyId
                ...GStory
            }
        }
    }

    ${G_STORY_FRAGMENT}
`;

export const G_ASSIGN_ROOM_TO_PROGRAM = gql`
    mutation AssignRoomToGuideProgram(
        $guideId: String!
        $guideProgramItemId: String!
        $worldMapMarkerId: String!
        $token: String
    ) {
        g_assignRoomToProgramItem(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            worldMapMarkerId: $worldMapMarkerId
            token: $token
        ) {
            guide {
                guideId
            }
            programItem {
                guideProgramItemId
                room {
                    worldMapMarkerId
                }
            }
        }
    }
`;

export const G_UNASSIGN_ROOM_FROM_PROGRAM = gql`
    mutation UnassignRoomFromGuideProgram(
        $guideId: String!
        $guideProgramItemId: String!
        $token: String
    ) {
        g_unassignRoomFromProgramItem(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            token: $token
        ) {
            guide {
                guideId
            }
            programItem {
                guideProgramItemId
                room {
                    worldMapMarkerId
                }
            }
        }
    }
`;

export const G_CREATE_STORY_TO_GUIDE_INFORMATION = gql`
    mutation CreateStoryToGuideInformation(
        $guideId: String!
        $story: StoryInput!
        $cards: [CardInputWithType!]!
        $token: String
    ) {
        g_createStoryToGuide(
            guideId: $guideId
            story: $story
            cards: $cards
            token: $token
            assingToInformation: true
        ) {
            guide {
                guideId
                stories {
                    storyId
                }
                informationItems {
                    guideInformationItemId
                    storyId
                }
            }
            story {
                storyId
                ...GStory
            }
        }
    }

    ${G_STORY_FRAGMENT}
`;

export const G_CREATE_CATEGORY = gql`
    mutation CreateCategory(
        $guideId: String
        $worldMapId: String!
        $input: WorldMapSetInput!
        $token: String
    ) {
        g_createCategory(
            guideId: $guideId
            worldMapId: $worldMapId
            worldMapSet: $input
            token: $token
        ) {
            guide {
                guideId
                categories {
                    worldMapSetId
                }
            }
            category {
                worldMapSetId
                title
            }
        }
    }
`;

export const G_UPDATE_CATEGORY = gql`
    mutation UpdateCategory(
        $guideId: String
        $worldMapSetId: String!
        $input: WorldMapSetInput!
        $token: String
    ) {
        g_updateCategory(
            guideId: $guideId
            worldMapSetId: $worldMapSetId
            worldMapSet: $input
            token: $token
        ) {
            guide {
                guideId
                categories {
                    worldMapSetId
                }
            }
            category {
                worldMapSetId
                title
                color
                imageUrl
            }
        }
    }
`;

export const G_DELETE_CATEGORY = gql`
    mutation DeleteCategory($guideId: String, $worldMapSetId: String!, $token: String) {
        g_deleteCategory(guideId: $guideId, worldMapSetId: $worldMapSetId, token: $token) {
            guide {
                guideId
                categories {
                    worldMapSetId
                }
            }
        }
    }
`;

export const G_ADD_STORY_TO_CATEGORY = gql`
    mutation AddStoryToCategory(
        $guideId: String
        $storyId: String!
        $worldMapSetId: String!
        $token: String
    ) {
        g_addToCategory(
            guideId: $guideId
            storyId: $storyId
            worldMapSetId: $worldMapSetId
            token: $token
        ) {
            guide {
                guideId
                stories {
                    storyId
                    categories {
                        worldMapSetId
                    }
                }
            }
            category {
                worldMapSetId
            }
        }
    }
`;

export const G_REMOVE_STORY_FROM_CATEGORY = gql`
    mutation RemoveStoryFromCategory(
        $guideId: String
        $storyId: String!
        $worldMapSetId: String!
        $token: String
    ) {
        g_removeFromCategory(
            guideId: $guideId
            storyId: $storyId
            worldMapSetId: $worldMapSetId
            token: $token
        ) {
            guide {
                guideId
                stories {
                    storyId
                    categories {
                        worldMapSetId
                    }
                }
            }
            category {
                worldMapSetId
            }
        }
    }
`;

export const G_ADD_EXTERNAL_POINT_TO_CATEGORY = gql`
    mutation AddExternalPointToCategory(
        $guideId: String
        $externalPointId: String!
        $worldMapSetId: String!
    ) {
        g_addExternalPointToCategory(
            guideId: $guideId
            externalPointId: $externalPointId
            worldMapSetId: $worldMapSetId
        ) {
            guide {
                guideId
                externalPoints {
                    externalPointId
                    categories {
                        worldMapSetId
                    }
                }
            }
            category {
                worldMapSetId
            }
        }
    }
`;

export const G_REMOVE_EXTERNAL_POINT_FROM_CATEGORY = gql`
    mutation RemoveExternalPointFromCategory(
        $guideId: String
        $externalPointId: String!
        $worldMapSetId: String!
    ) {
        g_removeExternalPointFromCategory(
            guideId: $guideId
            externalPointId: $externalPointId
            worldMapSetId: $worldMapSetId
        ) {
            guide {
                guideId
                externalPoints {
                    externalPointId
                    categories {
                        worldMapSetId
                    }
                }
            }
            category {
                worldMapSetId
            }
        }
    }
`;

export const G_DELETE_STORY = gql`
    mutation DeleteStoryFromGuide($storyId: String!, $guideId: String!, $token: String) {
        g_deleteStoryFromGuide(storyId: $storyId, guideId: $guideId, token: $token) {
            guide {
                guideId
                stories {
                    storyId
                }
                entityTypes {
                    guideEntityTypeId
                    storyIds
                }
                programItems {
                    guideProgramItemId
                    storyIds
                }
                informationItems {
                    guideInformationItemId
                }
            }
        }
    }
`;

export const G_CREATE_STORY = gql`
    mutation CreateGuideStory(
        $guideId: String!
        $story: StoryInput!
        $cards: [CardInputWithType!]!
        $assignToEntityTypeId: String
        $addToCategoriesId: [String!]
        $reuploadImages: Boolean
        $token: String
    ) {
        g_createStoryToGuide(
            guideId: $guideId
            story: $story
            cards: $cards
            assignToEntityTypeId: $assignToEntityTypeId
            addToCategoriesId: $addToCategoriesId
            reuploadImages: $reuploadImages
            token: $token
        ) {
            guide {
                guideId
                stories {
                    storyId
                }
            }
            story {
                storyId
                ...GStory
            }
        }
    }
    ${G_STORY_FRAGMENT}
`;

export const G_UPDATE_STORY = gql`
    mutation UpdateGuideStory(
        $guideId: String!
        $storyId: String!
        $story: StoryInput!
        $cards: [CardInputWithType!]!
        $addToCategoriesId: [String!]
        $reuploadImages: Boolean
        $token: String
    ) {
        g_updateStoryToGuide(
            guideId: $guideId
            storyId: $storyId
            story: $story
            cards: $cards
            addToCategoriesId: $addToCategoriesId
            reuploadImages: $reuploadImages
            token: $token
        ) {
            guide {
                guideId
            }
            story {
                storyId
                ...GStory
            }
        }
    }

    ${G_STORY_FRAGMENT}
`;

export const G_UPDATE_PROGRAM_RESERVATION = gql`
    mutation UpdateProgramReservation(
        $guideId: String!
        $guideProgramItemId: String!
        $reservationSlotsCount: Int
    ) {
        g_updateProgramBookingSettings(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            reservationSlotsCount: $reservationSlotsCount
        ) {
            programItem {
                ...GProgramItem
            }
        }
    }

    ${G_PROGRAM_ITEM}
`;

export const G_ADD_EXTERNAL_LINK = gql`
    mutation AddExternalLink(
        $guideId: String!
        $externalLink: GuideExternalLinkInput!
        $token: String
    ) {
        g_addExternalLink(guideId: $guideId, externalLink: $externalLink, token: $token) {
            guide {
                guideId
                externalLinks {
                    guideExternalLinkId
                }
            }
            externalLink {
                ...GExternalLink
            }
        }
    }

    ${G_EXTERNAL_LINK}
`;

export const G_UPDATE_EXTERNAL_LINK = gql`
    mutation UpdateExternalLink(
        $guideId: String!
        $guideExternalLinkId: String!
        $externalLink: GuideExternalLinkInput!
        $token: String
    ) {
        g_updateExternalLink(
            guideId: $guideId
            guideExternalLinkId: $guideExternalLinkId
            externalLink: $externalLink
            token: $token
        ) {
            guide {
                guideId
                externalLinks {
                    guideExternalLinkId
                }
            }
            externalLink {
                ...GExternalLink
            }
        }
    }

    ${G_EXTERNAL_LINK}
`;

export const G_DELETE_EXTERNAL_LINK = gql`
    mutation DeleteExternalLink($guideId: String!, $guideExternalLinkId: String!, $token: String) {
        g_deleteExternalLink(
            guideId: $guideId
            guideExternalLinkId: $guideExternalLinkId
            token: $token
        ) {
            guide {
                guideId
                externalLinks {
                    guideExternalLinkId
                }
            }
        }
    }
`;

export const G_REORDER_INFORMATION_ITEMS = gql`
    mutation ReorderInformationItems($guideId: String!, $order: [String!]!, $token: String) {
        g_reorderInformationItems(guideId: $guideId, order: $order, token: $token) {
            guide {
                guideId
                informationItems {
                    guideInformationItemId
                }
            }
        }
    }
`;

export const G_REORDER_WORLD_MAP_SETS = gql`
    mutation ReorderWorldMapSets($guideId: String!, $order: [String!]!, $token: String) {
        g_reorderWorldMapSets(guideId: $guideId, order: $order, token: $token) {
            guide {
                guideId
                categories {
                    worldMapSetId
                    orderIndex
                }
            }
        }
    }
`;

export const G_REORDER_STORIES_FOR_PROGRAM_ITEM = gql`
    mutation ReoredStoriesForProgramItem(
        $guideId: String!
        $guideProgramItemId: String!
        $order: [String!]!
        $token: String
    ) {
        g_reorderStoriesForProgramItem(
            guideId: $guideId
            guideProgramItemId: $guideProgramItemId
            order: $order
            token: $token
        ) {
            guide {
                guideId
            }
            programItem {
                guideProgramItemId
                storyIds
            }
        }
    }
`;

export const E_SUBMIT_FORM_MUTATION = gql`
    mutation SubmitForm($eventId: String!, $eventFormId: String!, $data: JSONObject!) {
        e_submitForm(eventId: $eventId, eventFormId: $eventFormId, data: $data)
    }
`;

export const UPDATE_EVENT_USER_INFORMATION_BY_TOKEN_MUTATION = gql`
    mutation UpdateEventUserInformationByTokenMutation(
        $eventId: String!
        $userId: String!
        $token: String!
        $information: EventUserInformationInput!
    ) {
        e_updateUserInformation_useToken(
            eventId: $eventId
            userId: $userId
            token: $token
            information: $information
        ) {
            firstName
            lastName
            companyName
            jobPosition
            publicDescription
            linkedIn
            websiteUrl
            networkingTopicOptionIds
        }
    }
`;

export const G_LINK_EXETRNAL_POINT = gql`
    mutation LinkExternalPointToGuide($guideId: String!, $externalPointId: String!) {
        g_linkExternalPointToGuide(guideId: $guideId, externalPointId: $externalPointId) {
            guide {
                guideId
                externalPoints {
                    externalPointId
                }
            }
        }
    }
`;

export const G_UNLINK_EXETRNAL_POINT = gql`
    mutation UnlinkExternalPointFromGuide($guideId: String!, $externalPointId: String!) {
        g_unlinkExternalPointFromGuide(guideId: $guideId, externalPointId: $externalPointId) {
            guide {
                guideId
                externalPoints {
                    externalPointId
                }
            }
        }
    }
`;

export const FORM_CREATE_MUTATION = gql`
    mutation CreateForm($title: String) {
        createForm(title: $title) {
            eventFormId
        }
    }
`;

export const FORM_DELETE_MUTATION = gql`
    mutation DeleteForm($eventFormId: String!) {
        deleteForm(eventFormId: $eventFormId) {
            success
        }
    }
`;

export const FORM_UPDATE_MUTATION = gql`
    mutation UpdateForm($eventFormId: String!, $form: EventFormInput!) {
        updateForm(eventFormId: $eventFormId, form: $form) {
            eventFormId
            ...EEventForm
        }
    }

    ${EVENT_FORM_FRAGMENT}
`;
